<div class="row">
  <div class="col-md-12">
    <div class="minititulo">Mi buscador</div>
    <div class="titulo">Buscador de usuarios</div>

    <form [formGroup]="rutABuscar" (ngSubmit)="buscarRut()">
      <label>Rut Beneficiario</label>

      <input
        type="text"
        class="form-control search-input"
        formControlName="rutBbdd"
        placeholder="Ingrese el RUT"
        (input)="changeRut()"
        required
      >

      <button type="submit" class="btn boton mt-3">Buscar</button>
    </form>
  </div>
</div>

<div *ngIf="busquedaRealizada && plansList.length === 0" class="not-appointment">
  <i class="fi fi-rr-info"></i>
  <span>El rut ingresado no es parte de ningún plan.</span>
</div>

<div class="card mt-4" *ngIf="plansList.length > 0">
  <div class="card-header">
    <span class="header-card">Información Rut: {{ plansList[0]?.r_benefciciario }}</span>
    <p class="mb-0">
      Estado de cuenta:
      <span
        class="badge-status"
        [ngClass]="{
          'active': plansList[0].status_cuenta === 'activo',
          'inactive': plansList[0].status_cuenta === 'inactivo',
          'pending': plansList[0].status_cuenta === 'pendiente'
        }"
      >
        {{ plansList[0].status_cuenta | uppercase }}
      </span>
    </p>
  </div>

  <div class="card-body">
    <div class="section-title">Planes Vigentes</div>

    <div class="table-responsive">
      <table class="table table-custom">
        <thead>
          <tr>
            <th>Plan</th>
            <th>Póliza</th>
            <th>Folio</th>
            <th>Tipo</th>
            <th>Descripción</th>
            <th>Inicio</th>
            <th>Término</th>
            <th>Estado</th>
            <th class="text-center">Historial</th>
          </tr>
        </thead>

        <tbody>
  <ng-container *ngFor="let grupo of planesAgrupados">
    <tr>
      <td><img [src]="grupo.planActual.cus_url_image_web" class="logo-plan"></td>
      <td>{{ grupo.planActual.poliza }}</td>
      <td>{{ grupo.planActual.folio }}</td>
      <td>{{ grupo.planActual.t_usuario }}</td>
      <td>{{ grupo.planActual.cus_ben_name }}</td>
      <td>{{ grupo.planActual.fecha_inicio | date:'dd/MM/yyyy' }}</td>
      <td>{{ grupo.planActual.fecha_termino | date:'dd/MM/yyyy' }}</td>
      <td>
        <span class="badge-status"
          [ngClass]="{
            'active': grupo.planActual.status_plan == 'activo',
            'inactive': grupo.planActual.status_plan != 'activo'
          }">
          {{ grupo.planActual.status_plan }}
        </span>
      </td>
      <td class="text-center">
        <button
          *ngIf="grupo.historial.length > 0"
          type="button"
          class="btn btn-sm btn-history"
          (click)="toggleHistorial(grupo)">
          {{ grupo.expanded ? 'Ocultar' : 'Historial' }}
        </button>
      </td>
    </tr>

    <tr *ngIf="grupo.expanded">
      <td colspan="8" class="history-wrapper">
        <div class="history-box">
          <div class="history-title">
            Historial de la póliza {{ grupo.poliza }}
          </div>

          <table class="table table-history mb-0">
            <thead>
              <tr>
                <th>Plan</th>
                <th>Póliza</th>
                <th>Folio</th>
                <th>Tipo</th>
                <th>Descripción</th>
                <th>Inicio</th>
                <th>Término</th>
                <th>Estado</th>
                <th>Folio</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let hist of grupo.historial">
                <td><img [src]="hist.cus_url_image_web" class="logo-plan"></td>
                <td>{{ hist.poliza }}</td>
                <td>{{ hist.folio }}</td>
                <td>{{ hist.t_usuario }}</td>
                <td>{{ hist.cus_ben_name }}</td>
                <td>{{ hist.fecha_inicio | date:'dd/MM/yyyy' }}</td>
                <td>{{ hist.fecha_termino | date:'dd/MM/yyyy' }}</td>
                <td>{{ hist.status_plan }}</td>
                <td>{{ hist.folio || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </td>
    </tr>
  </ng-container>
</tbody>
      </table>
    </div>
  </div>
</div>